import React from "react";
import "./Certifications.css";

const certs = [
  {
    icon: "🏆",
    title: "GATE CSE Qualified (2026)",
    desc: "Graduate Aptitude Test in Engineering — Computer Science.",
    highlight: true,
  },
  {
    icon: "⚛",
    title: "Advanced React — Meta (2024)",
    desc: "Advanced React.js: Hooks, Context API, and component architecture.",
  },
  {
    icon: "🤖",
    title: "AI Agents Fundamentals — Hugging Face (2026)",
    desc: "Building and deploying AI agent workflows with modern LLM tooling.",
  },
  {
    icon: "✦",
    title: "Google Prompting Essentials Specialisation (2026)",
    desc: "Prompt engineering and effective LLM interaction patterns.",
  },
  {
    icon: "🐳",
    title: "Docker Essentials: A Developer Introduction (2025)",
    desc: "Containerisation fundamentals for development and deployment.",
  },
];

function Certifications() {
  return (
    <section id="certifications" className="certifications section-band">
      <div className="section-inner">
        <header className="section-header">
          <div className="section-label">Achievements</div>
          <h2 className="section-title">
            Certs & <em>Recognition</em>
          </h2>
          <p className="section-subtitle">
            Industry-recognised credentials in React, AI, Docker, and competitive engineering.
          </p>
        </header>

        <div className="cert__grid">
          {certs.map((c) => (
            <div
              key={c.title}
              className={`cert__item ui-card reveal${c.highlight ? " cert__item--highlight" : ""}`}
            >
              <div className="cert__icon">{c.icon}</div>
              <div className="cert__text">
                <strong>{c.title}</strong>
                <span className="card-body">{c.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Certifications;
